import { preservationDirective } from '../../../core/constants/clivage';

// Arma el body del POST /admin/embryos (solo EXTERNOS). Donante XOR: donor_id
// (animal existente) | donor_animal (anidado nombre + raza + registro opcional).
// La preservación (un solo selector) aterriza en { storage, method } (0009 §4):
// `storage` es obligatorio; `method` solo si es congelado. `clivage_id` está
// PROHIBIDO en esta ruta (los OPU nacen del clivage) → nunca se envía.
export function buildEmbryoPayload(form) {
    const out = {
        semen_id: form.semen.id,
        code: form.code.trim(),
    };

    const dir = preservationDirective(form.preservation);
    out.storage = dir.storage;
    if (dir.method) out.preservation = { method: dir.method };

    if (form.stage) out.stage = form.stage;
    if (form.sex) out.sex = form.sex;
    if (form.quality.trim()) out.quality = form.quality.trim();

    if (form.donorMode === 'new') {
        const da = { name: form.donor_name.trim(), race_id: Number(form.donor_race_id) };
        if (form.donor_register.trim()) da.register = form.donor_register.trim();
        out.donor_animal = da;
    } else {
        out.donor_id = form.donor.id;
    }

    if (form.remarks.trim()) out.remarks = form.remarks.trim();
    return out;
}
